import type { PrismicRichTextProps } from "@prismicio/react"
import { PrismicRichText } from "@prismicio/react"

import { linkResolver } from "~/api/prismic/linkResolver"
import { getRichTextBlocks } from "~/utils/prismic/assertJsonTypes"

type CustomRichTextProps = Omit<PrismicRichTextProps, "field"> & {
  field: prismic.ImageDetails | PrismicRichTextProps["field"]
}

const CustomRichText: React.FC<CustomRichTextProps> = ({ field, ...props }) => {
  return (
    <PrismicRichText
      {...props}
      linkResolver={linkResolver}
      field={getRichTextBlocks(field)}
    />
  )
}

export default CustomRichText
